// import axios from "axios";
import secure_axios from "../../services/secure_axios";

const initialState = () =>({
  summarydata: {},
  customersdata: [],
  customerdata: {},
  customerproducts: [],
  customeroutsdocs: [],
  customeroutsmonthly: [],
});
const state = initialState();
const getters = {
  summarydata: (state) => state.summarydata,
  customersdata: (state) => state.customersdata,
  customerdata: (state) => state.customerdata,
  customerproducts: (state) => state.customerproducts,
  customeroutsdocs: (state) => state.customeroutsdocs,
  customeroutsmonthly: (state) => state.customeroutsmonthly,
};

const mutations = {
  setSummaryData(state, payload) {
    state.summarydata = payload;
  },
  setCustomersData(state, payload) {
    state.customersdata = payload;
  },
  setCustomerData(state, payload) {
    state.customerdata = payload;
  },
  setAllCustomerProducts(state, payload) {
    state.customerproducts = payload;
  },
  setCustomerOutsDocs(state, payload) {
    state.customeroutsdocs = payload;
  },
  setCustomerOutsMonthly(state, payload) {
    state.customeroutsmonthly = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getSummaryData({ commit,getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const smandocno = payload.smandocno;
    const fromDate = payload.fromDate;
    const toDate = payload.toDate;
    const dates  = payload.dates ;
    secure_axios
      .get(`${getters.sessionAPI}summarydata?smandocno=${smandocno}&dates=${dates}&fromDate=${fromDate}&toDate=${toDate}`)
      .then((response) => {
        commit("setSummaryData", response.data.summarydata);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  getCustomersData({ commit, getters }, payload) {
    commit("setCustomersData", []);
    commit("setLoading", true);
    commit("clearError");

    const smandocno = payload.smandocno;
    const search = payload.search;
    const doctype = payload.doctype;
    const docno = payload.docno;
    const blockstat = payload.blockstat;
    const lastinv = payload.lastinv;
    const oldinv = payload.oldinv;
    const skip = payload.skip;
    const sortby = payload.sortby;
    const sortord = payload.sortord;

    secure_axios
      .get(
        `${getters.sessionAPI}customersdatalist?smandocno=${smandocno}&search=${search}&doctype=${doctype}&docno=${docno}&blockstat=${blockstat}&lastinv=${lastinv}&oldinv=${oldinv}&skip=${skip}&sortby=${sortby}&sortord=${sortord}`
      )
      .then((response) => {
        commit("setCustomersData", response.data.customerdata);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  getCustomerData({ commit, getters }, payload) {
    commit("setCustomerData", {});
    commit("setLoading", true);
    commit("clearError");
    const doctype = payload.doctype;
    const docno = payload.docno;

    secure_axios
      .get(`${getters.sessionAPI}customerdatalist?&doctype=${doctype}&docno=${docno}`)
      .then((response) => {
        commit("setCustomerData", response.data.onecustomerdata);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  getAllCustProducts({ commit, getters }, payload) {
    commit("setAllCustomerProducts", []);
    commit("setLoading", true);
    commit("clearError");

    const doctype = payload.doctype;
    const docno = payload.docno;

    secure_axios
      .get(`${getters.sessionAPI}customerproducts?doctype=${doctype}&docno=${docno}`)
      .then((response) => {
        commit("setAllCustomerProducts", response.data.customerproducts);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  getCustomerOutsDocs({ commit, getters }, payload) {
    commit("setCustomerOutsDocs", []);
    commit("setLoading", true);
    commit("clearError");

    const doctype = payload.doctype;
    const docno = payload.docno;

    secure_axios
      .get(`${getters.sessionAPI}customeroutsdocs?doctype=${doctype}&docno=${docno}`)
      .then((response) => {
        commit("setCustomerOutsMonthly", response.data.customerouts.customeroutsmonthly);
        commit("setCustomerOutsDocs", response.data.customerouts.customeroutsdocs);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
